export default __webpack_public_path__ + "static/compareItemImg5-72d41cbcf906bc51a82c95ac161d7c47.webp";